// eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
import {useState, useEffect, Component} from 'react';
import {Link} from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

import {StanfordFooter} from './StanfordFooter';
import {FaLinkedin, FaTwitter} from 'react-icons/fa';
import {useTranslateFunction} from 'contexts/translation/TranslationContext';

interface FooterProps {
  /**
   * Overrides the "Code in Place" brand link text shown in the footer (e.g.
   * for sub-apps like PAI that share this Footer but aren't branded as Code
   * in Place). Defaults to the translated "Code in Place" string.
   */
  brandName?: string;
}

export const Footer = ({brandName}: FooterProps = {}) => {
  const [width, setWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleWindowResize);

    // Return a function from the effect that removes the event listener
    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  return width < 850 ? (
    <div>
      <FooterMobile brandName={brandName} />
      <StanfordFooter />
    </div>
  ) : (
    <div>
      <FooterBrowser brandName={brandName} />
      <StanfordFooter />
    </div>
  );
};

const FooterMobile = ({brandName}: FooterProps) => {
  const t = useTranslateFunction('landing');
  return (
    <div className="footerContainer">
      <div className="container">
        <div className="row">
          <div className="col">
            <div className="footerContent d-flex justify-content-between">
              <div>
                <Link className="footerLink mr-3" to="/">
                  {brandName ?? t('Code in Place')}
                </Link>

                <Link className="footerLink ml-3 mr-3" to="/team">
                  {t('Team')}
                </Link>

                {/* <Link className="footerLink mr-3" to="/cip-faq">
                    FAQ
                  </Link> */}

                <Link className="footerLink ml-3 mr-3" to="/terms-of-service">
                  {t('Terms')}
                </Link>

                <Link className="footerLink ml-3 mr-3" to="/contact">
                  {t('Contact')}
                </Link>
              </div>
              <div>
                <a
                  href="https://twitter.com/sectionleadcs"
                  className="footerLink"
                >
                  <FaTwitter />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const FooterBrowser = ({brandName}: FooterProps) => {
  const t = useTranslateFunction('landing');
  return (
    <div className="footerContainer">
      <div className="container">
        <div className="row">
          <div className="col">
            <div className="footerContent d-flex justify-content-between">
              <div>
                <Link className="footerLink mr-3" to="/">
                  {brandName ?? t('Code in Place')}
                </Link>

                <Link className="footerLink ml-3 mr-3" to="/team">
                  {t('The Team')}
                </Link>

                {/* <Link className="footerLink ml-3  mr-3" to="/cip-faq">
                  FAQ
                </Link> */}

                <Link className="footerLink ml-3 mr-3" to="/terms-of-service">
                  {t('Terms of Service')}
                </Link>

                <Link className="footerLink ml-3" to="/contact">
                  {t('Contact Us')}
                </Link>
              </div>
              <div className="socialBits">
                <a
                  href="https://www.linkedin.com/school/stanford-code-in-place/"
                  className="footerLink mr-2"
                  aria-label={t('Stanford Code in Place LinkedIn') as string}
                >
                  <FaLinkedin />
                </a>
                <a
                  href="https://twitter.com/sectionleadcs"
                  className="footerLink"
                  aria-label={
                    t(
                      'Stanford Computer Science Section Leaders Twitter',
                    ) as string
                  }
                >
                  <FaTwitter />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
